.radio-group__wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.radio-group__header {
  font-family: inherit;
  font-size: inherit;
  line-height: var(--line-height-s);
  margin: 0;
}

.radio-group {
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-600);
  border-radius: 0.25rem;
  overflow: hidden;
}

.radio-group__option {
  cursor: pointer;
  display: flex;
  gap: 1rem;
  padding: 1rem;
}

.radio-group__option:not(:last-of-type) {
  border-bottom: 1px solid var(--color-grey-400);
}

.radio-group__option:hover {
  background-color: var(--color-grey-300);
}

.radio-group__option--disabled {
  cursor: default;
  pointer-events: none;
}
